import styled from "styled-components";

export const SubContainer = styled.div`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  background: #fff;
  // position: fixed;
  // width: 100%;
  // margin-top: -6rem;
  // transform: translateY(-2rem);
  // z-index: 10000;
  // border: 3px solid brown;

  @media screen and (max-width: 991px) {
    box-shadow: none;
  }
  @media screen and (max-width: 579px) {
    box-shadow: none;
  }
`;

export const Container = styled.div`
  // border: 3px solid red;
  max-width: 1480px;
  margin: auto;
  padding-left: 5rem;
  padding-right: 5rem;

  @media screen and (max-width: 991px) {
    // display: none;
  }
  @media screen and (max-width: 579px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const NavWrapper = styled.div`
  padding-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .menu__icon{
      display: none;
  }
  @media screen and (max-width: 991px) {
    .menu__icon {
      display: inline-block;
    }
  }
`;
export const NavItem = styled.div`
  a {
    // border: 3px solid
    margin-right: 2rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  .active {
    border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
    padding: 8px 0px;
  }

  @media screen and (max-width: 991px) {
    display: none;
    .menu__icon{
        display: inline-block;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const BurgerNav = styled.div`
  display: none;
  @media screen and (max-width: 991px) {
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    background-color: ${(props) =>
      props.mode === "dark" ? "#232323" : "#fff"};
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    box-shadow: 8px 16px 16px hsl(0deg 0% 0% / 0.25);
    border: 3px solid transparent;
    transform: ${(props) =>
      props.show ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.2s;
    .active {
      // border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
      font-weight: bold;
    
    }
    div:nth-of-type(2) {
      background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1652353267/invest-trust/blue_Opaque_shield_logo_lgommu.png");
      // background-position: center;
      display: flex;
      flex-direction: column;
      margin-left: 1rem;
      margin-right: 1rem;
    }
    
    a {
      margin-left: 2rem;
      margin-right: 2rem;
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      color: #000;
      font-size: 18px;
      width: 60%;
    }
  }
`;

export const CustomNav = styled.div`
  display: none;
  @media screen and (max-width: 991px) {
    display: inline-block;
    cursor: pointer;
    margin-top: 0.5rem;
  }
`;
export const CustomClose = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
  margin-left: 1rem;
  cursor: pointer;
  z-index: 100000;
`;
export const BurgerLogo = styled.div`
  transform: translateY(-2.5rem);
  margin-left: -1rem;
`;
